// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separateLayout-module_separateLayout__BGW52 {
    --expandedShadowColor: var(--black_48_tr_base);
    height: 100dvh;
    display: flex;
    flex-direction: column;
}

.separateLayout-module_separateLayoutOverlay__YHNYj {
    --overlay-opacity: 0;
    --overlay-zIndex: -1;
    opacity: var(--overlay-opacity);
    transition: opacity 0.3s ease-in-out;
    background-color: var(--expandedShadowColor);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: var(--overlay-zIndex);

}

.separateLayout-module_overlay__cXWGC {
    --overlay-opacity: 1;
    --overlay-zIndex: 1;
}

.separateLayout-module_separateLayoutBottom__ttKL_ {
    --bottom-overflowY: hidden;
    --bottom-top: 0px;
    --bottom-overscroll-behavior: auto;
    overflow-y: var(--bottom-overflowY);
    overflow-x: hidden;
    background-color: var(--white);
    transition: top 0.3s ease-out;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: var(--bottom-top);
    overscroll-behavior: var(--bottom-overscroll-behavior);
    z-index: 2;
}

.separateLayout-module_separateLayoutBottom__ttKL_::-webkit-scrollbar {
    display: none;
}

.separateLayout-module_separateLayoutBottomInner__hx4X9 {
    --bottomInner-top: 260px;
    --bottomInner-min-height: 0px;
    min-height: calc(100dvh - var(--bottomInner-min-height));
    transition: min-height 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    width: 100%;
}

@keyframes separateLayout-module_expandCollapseLayout__tCjOH {

    0% {
        min-height: calc(100dvh - var(--bottomInner-top));
    }
    100% {
        min-height: calc(100dvh - 60px);
    }
}

@keyframes separateLayout-module_collapseExpandLayout__x2pWQ {
    0% {
        min-height: calc(100dvh - 60px);
    }
    100% {
        min-height: calc(100dvh - var(--bottomInner-top));
    }
}

.separateLayout-module_animationExpandCollapseLayout__f66DS {
    animation: separateLayout-module_expandCollapseLayout__tCjOH 0.3s ease-in-out forwards;
}

.separateLayout-module_animationCollapseExpandLayout__c5meV {
    animation: separateLayout-module_collapseExpandLayout__x2pWQ 0.3s ease-in-out forwards;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/layout/css/separateLayout.module.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,+BAA+B;IAC/B,oCAAoC;IACpC,4CAA4C;IAC5C,SAAS;IACT,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,8BAA8B;;AAElC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kCAAkC;IAClC,mCAAmC;IACnC,kBAAkB;IAClB,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,wDAAwD;IACxD,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;;IAEI;QACI,iDAAiD;IACrD;IACA;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;IACA;QACI,iDAAiD;IACrD;AACJ;;AAEA;IACI,sFAAyD;AAC7D;;AAEA;IACI,sFAAyD;AAC7D","sourcesContent":[".separateLayout {\n    --expandedShadowColor: var(--black_48_tr_base);\n    height: 100dvh;\n    display: flex;\n    flex-direction: column;\n}\n\n.separateLayoutOverlay {\n    --overlay-opacity: 0;\n    --overlay-zIndex: -1;\n    opacity: var(--overlay-opacity);\n    transition: opacity 0.3s ease-in-out;\n    background-color: var(--expandedShadowColor);\n    bottom: 0;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: var(--overlay-zIndex);\n\n}\n\n.overlay {\n    --overlay-opacity: 1;\n    --overlay-zIndex: 1;\n}\n\n.separateLayoutBottom {\n    --bottom-overflowY: hidden;\n    --bottom-top: 0px;\n    --bottom-overscroll-behavior: auto;\n    overflow-y: var(--bottom-overflowY);\n    overflow-x: hidden;\n    background-color: var(--white);\n    transition: top 0.3s ease-out;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: var(--bottom-top);\n    overscroll-behavior: var(--bottom-overscroll-behavior);\n    z-index: 2;\n}\n\n.separateLayoutBottom::-webkit-scrollbar {\n    display: none;\n}\n\n.separateLayoutBottomInner {\n    --bottomInner-top: 260px;\n    --bottomInner-min-height: 0px;\n    min-height: calc(100dvh - var(--bottomInner-min-height));\n    transition: min-height 0.3s ease-in-out;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n@keyframes expandCollapseLayout {\n\n    0% {\n        min-height: calc(100dvh - var(--bottomInner-top));\n    }\n    100% {\n        min-height: calc(100dvh - 60px);\n    }\n}\n\n@keyframes collapseExpandLayout {\n    0% {\n        min-height: calc(100dvh - 60px);\n    }\n    100% {\n        min-height: calc(100dvh - var(--bottomInner-top));\n    }\n}\n\n.animationExpandCollapseLayout {\n    animation: expandCollapseLayout 0.3s ease-in-out forwards;\n}\n\n.animationCollapseExpandLayout {\n    animation: collapseExpandLayout 0.3s ease-in-out forwards;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separateLayout": `separateLayout-module_separateLayout__BGW52`,
	"separateLayoutOverlay": `separateLayout-module_separateLayoutOverlay__YHNYj`,
	"overlay": `separateLayout-module_overlay__cXWGC`,
	"separateLayoutBottom": `separateLayout-module_separateLayoutBottom__ttKL_`,
	"separateLayoutBottomInner": `separateLayout-module_separateLayoutBottomInner__hx4X9`,
	"animationExpandCollapseLayout": `separateLayout-module_animationExpandCollapseLayout__f66DS`,
	"expandCollapseLayout": `separateLayout-module_expandCollapseLayout__tCjOH`,
	"animationCollapseExpandLayout": `separateLayout-module_animationCollapseExpandLayout__c5meV`,
	"collapseExpandLayout": `separateLayout-module_collapseExpandLayout__x2pWQ`
};
export default ___CSS_LOADER_EXPORT___;
